<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-08-03 16:07:47
 * @LastEditors: sjq
 * @LastEditTime: 2023-08-07 18:48:59
 -->
<template>
  <div class="">
    <van-uploader
      :after-read="afterRead"
      :accept="'image/*'"
      v-model="fileList"
      @delete="deleteList"
      :max-count="num"
      class="m-uploader"
      :before-read="beforeRead"
    >
      <div class="add-box van-uploader__preview">
        <van-icon name="plus" />
      </div>
    </van-uploader>
  </div>
</template>
<script>
import { Uploader, Icon, Toast } from 'vant'
import { getToken } from '@/api/modules/qiniu'
import * as qiniu from 'qiniu-js'
import { saTrack } from '@/utils/common/shence'
import OSS from 'ali-oss'

export default {
  components: { 'van-uploader': Uploader, 'van-icon': Icon },
  props: {
    imgList: {},
    num: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      qiniuOption: {},
      qiniuData: null,
      compressOptions: {
        quality: 0.92,
        noCompressIfLarger: true
      },
      fileList: [],
      bg: '#ccc',
      client: ''
    }
  },
  computed: {
    // fileList() {
    //   console.log('object')
    //   return this.imgList
    // }
  },
  watch: {
    fileList() {
      console.log(this.fileList, 'fileList')
    },
    imgList() {
      this.fileList = this.imgList
    }
  },
  created() {
    console.log(this.qiniuInit())
  },
  mounted() {},
  methods: {
    beforeRead(file) {
      console.log(file, 'file')
      let isType = true
      let typeList = ['image/jpeg', 'image/png']
      if (file instanceof Array) {
        isType = file.filter(item => typeList.indexOf(item.type) === -1).length === 0
      } else {
        isType = typeList.indexOf(file.type) !== -1
      }
      if (!isType) Toast('请上传 jpg/png 格式图片')
      return isType
    },
    afterRead(file, detail) {
      if (file instanceof Array) {
        file.forEach((item, ind) => {
          item.status = 'uploading'
          item.message = '上传中...'
          this.aliyunUpload(item, detail.index + ind)
        })
      } else {
        file.status = 'uploading'
        file.message = '上传中...'
        this.aliyunUpload(file, detail.index)
      }
    },
    qiniuInit(file, index) {
      getToken('imageToken').then(res => {
        this.qiniuOption = { ...res }
        console.log(res, 'resss')
        this.client = new OSS({
          secure: true,
          region: 'oss-cn-beijing', // 示例：'oss-cn-hangzhou'，填写Bucket所在地域。
          accessKeyId: res.accessKeyId, // 确保已设置环境变量OSS_ACCESS_KEY_ID。
          accessKeySecret: res.accessKeySecret, // 确保已设置环境变量OSS_ACCESS_KEY_SECRET。
          bucket: res.bucket, // 示例：'my-bucket-name'，填写存储空间名称。
          stsToken: res.securityToken
        })
        if (file) {
          this.aliyunUpload(file, index)
        }
      })
    },
    deleteList(file, detail) {
      this.fileList.splice(detail.index, 0)
      this.$emit('upload', this.fileList)
    },
    async aliyunUpload(file, index) {
      try {
        // 构造上传文件的路径和名称
        const fileName = `activity/${Date.now()}_${file.file.name}`
        console.log(fileName, file, 'fileName, file')
        // 执行上传操作
        let result = await this.client.put(fileName, file.file)

        // 上传成功后处理
        console.log('上传成功:', result)
        // 假设你有一个 fileList 用于存储上传状态
        this.fileList[index].status = 'done'
        this.fileList[index].url = this.qiniuOption.accessPrefix + '/' + result.name // 或者根据实际需要构造文件的 URL
        this.$emit('upload', this.fileList) // 通知父组件上传状态更新
      } catch (err) {
        // 上传失败处理
        console.error('上传失败:', err)
        this.fileList[index].status = 'failed'
        this.fileList[index].message = '上传失败: ' + err.message
        this.$emit('upload', this.fileList) // 通知父组件上传状态更新

        // 根据错误类型进行特定处理（可选）
        if (err.code === 'AccessDenied') {
          // 处理访问被拒绝的错误
        }
        saTrack('h5_error_upload', {
          error_type: 1,
          error_detail: err
        })
      }
    }
  }
}
</script>
<style lang="scss">
.m-uploader {
  width: 100%;
  height: calc((100vw - 72px) / 3);
  .van-uploader__wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    overflow: hidden;
    height: 100%;
    .van-uploader__preview {
      margin: 0;
    }
    .van-uploader__preview-image {
      width: 100%;
      height: calc((100vw - 72px) / 3);
    }
    .van-uploader__preview-delete {
      width: 20px;
      height: 20px;
    }
    .van-uploader__preview-delete-icon {
      font-size: 24px;
    }
  }
}
</style>
<style lang="scss" scoped>
.add-box {
  border: dashed 1px #ccc;
  border-radius: 4px;
  color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
